import { render, staticRenderFns } from "./shop-distribution.vue?vue&type=template&id=79c8f192&scoped=true"
import script from "./shop-distribution.vue?vue&type=script&lang=ts"
export * from "./shop-distribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c8f192",
  null
  
)

export default component.exports